import React from 'react'
import { BookmarkedUrl } from '@/types/bookmark'

interface DeleteUrlConfirmModalProps {
  url: BookmarkedUrl
  onConfirm: () => void
  onCancel: () => void
}

/** 링크 삭제 확인 모달 */
const DeleteUrlConfirmModal: React.FC<DeleteUrlConfirmModalProps> = ({
  url,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="mx-4 w-96 rounded-lg bg-white p-6 dark:bg-gray-800">
        <h3 className="mb-4 text-lg font-semibold text-red-600 dark:text-red-400">
          링크 삭제
        </h3>
        <p className="mb-6 text-gray-700 dark:text-gray-300">
          정말로 "
          <strong>{url.metadata?.title || url.title || 'Untitled'}</strong>"
          링크를 삭제하시겠습니까?
          <br />
          <span className="mt-2 block text-sm text-gray-500 dark:text-gray-400">
            삭제된 링크는 복원할 수 없으며, 클릭 통계도 함께 삭제됩니다.
          </span>
        </p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
          >
            취소
          </button>
          <button
            onClick={onConfirm}
            className="rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700"
          >
            삭제
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteUrlConfirmModal
